export const getLinkColor = (item) => {
    let linkColor;

    if (item.cssClass && item.cssClass.indexOf('splash--red') > -1) {
        linkColor = 'attention';
    } else if (item.selected) {
        linkColor = 'strong';
    } else {
        linkColor = 'regular';
    }

    return linkColor;
};
